import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Site } from 'src/app/classes/models';
import { SharedDataService } from 'src/app/services/shared-data.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-site-admin',
  templateUrl: './site-admin.component.html',
  styleUrls: ['./site-admin.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SiteAdminComponent implements OnDestroy {
  sharedDataServiceSubscription!: Subscription;
  Site?: Site;

  constructor(
    private SharedDataService: SharedDataService,
    private ToastService: ToastService
  ) {
    this.sharedDataServiceSubscription = this.SharedDataService.listenForEvent<
      Site | undefined
    >().subscribe({
      next: ({ eventName, data }) => {
        if (eventName === 'setSiteData' && data instanceof Site) {
          this.Site = data;
        }
      }
    });

    this.SharedDataService.sendEvent('getSiteData');
  }

  activateSite() {
    if (!this.Site) {
      throw this.ToastService.addErrorToast(
        'Error',
        'No Site found. Cannot Activate Site.',
        { returnError: true }
      );
    }
    Object.assign(this.Site, { status: 'Active' });

    this.SharedDataService.sendEvent('updateSite', new Site(this.Site));
  }

  deActivateSite() {
    if (!this.Site) {
      throw this.ToastService.addErrorToast(
        'Error',
        'No Site found. Cannot Deactivate Site.',
        { returnError: true }
      );
    }
    Object.assign(this.Site, { status: 'Deactivated' });

    this.SharedDataService.sendEvent('updateSite', new Site(this.Site));
  }

  ngOnDestroy(): void {
    this.sharedDataServiceSubscription.unsubscribe();
  }
}
